var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: _vm.show } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(
              _vm._s(_vm.$ct("common.browse.quick-edit-extra-fields-label"))
            ),
          ]),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-list" } },
            _vm._l(_vm.fields, function (item) {
              return _c(
                "w-list-item",
                {
                  key: item.value,
                  on: {
                    click: function ($event) {
                      return _vm.selectField(item.value)
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: item.icon } })],
                    1
                  ),
                  _c("w-list-item-text", [_vm._v(_vm._s(item.text))]),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }